import React from "react";
import PageTableHeader from "../../../../components/pageTableHeader/pageTableHeader";
import ChangePaswordForm from "../../../../components/forms/settings/changePaswordForm";
import changePassword from "../../../../assets/images/changePassword.png";
const breadcrumbs = [
  { label: "Home", path: "/" },
  { label: "Change Password", path: "/change-password" },
];

const ChangePassword = () => {
  return (
    <div className="flex flex-col gap-2 p-4">
      <PageTableHeader
        breadcrumbs={breadcrumbs}
        isSearch={false}
        isFilter={false}
        buttons={false}
      />
      <div className="grid grid-cols-2 gap-4 p-4 bg-white items-center">
        <div className="h-90 w-90">
          <img src={changePassword} alt="" />
        </div>
        <div className="flex flex-col gap-12">
        <h2 className="font-bold text-4xl text-theme">Change Password</h2>
          <ChangePaswordForm />
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
